import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const RecieveCoinHistory = () => {
  const [received, setReceived] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);

  const coinDetails = JSON.parse(sessionStorage.getItem("coin"));

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const fetchReceivedHistory = async () => {
    try {
      setLoading(true);
      const payload = {
        userId: coinDetails.uniqueId,
        startDate: startDate ? `${startDate}T00:00:00` : undefined,
        endDate: endDate ? `${endDate}T23:59:59` : undefined,
      };

      const data = await fetch(
        `${process.env.REACT_APP_BASEURL3}/coin/recharge/received?page=${currentPage}&limit=${itemsPerPage}`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: { "Content-Type": "application/json" },
        }
      );

      const response = await data.json();
      if (response.success) {
        setReceived(response.received || []);
        setTotalItems(response.total || 0);
        setTotalAmount(response.totalAmount || 0);
      } else {
        setReceived([]);
        setTotalItems(0);
        setTotalAmount(0);
      }

      setLoading(false);
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    if (!coinDetails) {
      window.location.href = "/coin";
    } else {
      fetchReceivedHistory();
    }
  }, [currentPage, itemsPerPage]);

  const handlePrevPage = () => setCurrentPage((prev) => prev - 1);
  const handleNextPage = () => setCurrentPage((prev) => prev + 1);
  const handleChangeItemsPerPage = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <>
      <section className="content-header">
        <h1>Receive Coin History</h1>
      </section>

      <section className="content">
        <div className="row" style={{ marginBottom: "20px" }}>
          <div className="col-xs-3">
            <label>Start Date</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="col-xs-3">
            <label>End Date</label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <div className="col-xs-3">
            <label>&nbsp;</label>
            <button className="btn btn-primary form-control" onClick={fetchReceivedHistory}>
              Apply Filter
            </button>
          </div>
          <div className="col-xs-3 text-right">
            <div><b>Total Entries:</b> {totalItems}</div>
            <div><b>Total Amount:</b> {totalAmount}</div>
          </div>
        </div>

        <div className="pagination-options">
          <select
            className="form-control pagination-select"
            value={itemsPerPage}
            onChange={handleChangeItemsPerPage}
          >
            <option value="10">10 per page</option>
            <option value="50">50 per page</option>
            <option value="100">100 per page</option>
            <option value="500">500 per page</option>
            <option value="1000">1000 per page</option>
          </select>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="box">
              <div className="box-body">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>From</th>
                      <th>Coin</th>
                      <th>Date/Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr><td colSpan="4">Loading...</td></tr>
                    ) : (
                      received.map((item, index) => (
                        <tr key={index}>
                          <td>{indexOfFirstItem + index + 1}</td>
                          <td>Via Admin</td>
                          <td>
                            <label className="label label-success">{item.coin}</label>
                          </td>
                          <td>{new Date(item.createdAt).toLocaleString()}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="pagination-container">
                  <button
                    className="btn btn-default"
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  <button
                    className="btn btn-default"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RecieveCoinHistory;
